import React, { useState, useEffect } from 'react';
import './AgeVerification.css';

const AgeVerification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setIsVisible(true);
    }
  }, []);

  const handleYes = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVisible(false);
  };

  const handleNo = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="age-verification-overlay">
      <div className="age-verification-content">
        <h2>Are you of legal drinking age?</h2>
        <p>
          By entering this site, you are agreeing to our Terms of Service and Privacy Policy. This site uses cookies.
        </p>
        <div className="age-verification-buttons">
          <button onClick={handleYes}>Yes, I am 18+</button>
          <button onClick={handleNo}>No, I am not</button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;
